import React, { useState } from 'react';
import { Modal, Input, Form } from 'antd';

interface ResetPasswordModalProps {
    open: boolean;
    onOk: (password: string) => Promise<void>;
    onCancel: () => void;
    userName?: string;
}

const ResetPasswordModal: React.FC<ResetPasswordModalProps> = ({ open, onOk, onCancel, userName }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const validatePassword = (_: any, value: string) => {
        if (!value) {
            return Promise.reject('Please enter a password');
        }
        if (value.length < 8 || value.length > 64) {
            return Promise.reject('Password must be between 8 and 64 characters');
        }
        if (!/(?=.*[a-z])/.test(value)) {
            return Promise.reject('Password must contain at least one lowercase letter');
        }
        if (!/(?=.*[A-Z])/.test(value)) {
            return Promise.reject('Password must contain at least one uppercase letter');
        }
        if (!/(?=.*\d)/.test(value)) {
            return Promise.reject('Password must contain at least one number');
        }
        if (!/(?=.*[@$!%*?&#])/.test(value)) {
            return Promise.reject('Password must contain at least one special character (@$!%*?&#)');
        }
        return Promise.resolve();
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            await onOk(values.newPassword);
            form.resetFields();
        } catch (error) {
            console.error('Validation failed:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    return (
        <Modal
            title="Reset Password"
            open={open}
            onOk={handleOk}
            onCancel={handleCancel}
            confirmLoading={loading}
            okText="Reset Password"
            cancelText="Cancel"
            okButtonProps={{
                style: { backgroundColor: '#095179', color: '#ffffff' },
            }}
        >
            <Form form={form} layout="vertical">
                <p style={{ marginBottom: 16 }}>Reset password for: <strong>{userName}</strong></p>
                <Form.Item
                    name="newPassword"
                    label="New Password"
                    rules={[{ validator: validatePassword }]}
                >
                    <Input.Password placeholder="Enter new password" />
                </Form.Item>
                <div style={{ fontSize: 12, color: '#666' }}>
                    <p style={{ marginBottom: 4 }}>Password must contain:</p>
                    <ul style={{ paddingLeft: 20, margin: 0 }}>
                        <li>8-64 characters</li>
                        <li>One uppercase letter</li>
                        <li>One lowercase letter</li>
                        <li>One number</li>
                        <li>One special character (@$!%*?&#)</li>
                    </ul>
                </div>
            </Form>
        </Modal>
    );
};

export default ResetPasswordModal;
